module.exports = {
    totalWard: 7,
};
